import * as React from "react";
import { List, Box, Alert } from "@mui/material";

import { getPresenzeCantieri } from "../../service/cantieri";
import ItemCantiere from "./ItemCantiere"; 
import { useSnackbar } from "notistack";
import LoadingView from "../../components/LoadingView";

const Home = () => {

  const [results, setResults] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  const { enqueueSnackbar } = useSnackbar();

  React.useEffect(() => {

    getPresenzeCantieri().then((result) => {

      setResults(result.data); 

    }).catch(e => {

      enqueueSnackbar(e.message ? e.message : e, { variant: 'error' }); 

    }).finally(() => {

      setIsLoading(false); 

    });

  }, []);

  return (
    <Box>
    {isLoading === true ? (

      <LoadingView />

    ) : (

      results.length > 0 ? (

        <List sx={{ width: "100%", bgcolor: "background.paper" }}>
          {results.map((result, key) => <ItemCantiere key={key} cantiere={result} />)}
        </List>

      ) : (

        <Box>
          <Alert severity="info">Nessuna marcatura da mostrare</Alert>
        </Box>

      )

    )}
    </Box>
  );
};

export default Home;
